const RoleBadge = ({ role }) => {

    const map = {
        admin: "ادمین",
        staff: "کارکن",
        user: "کاربر"
    };

    const color = {
        admin: "bg-purple-100 text-purple-700",
        staff: "bg-blue-100 text-blue-700",
        user: "bg-gray-100 text-gray-700"
    };

    return (
        <span className={`px-3 py-1 rounded-full text-xs ${color[role]}`}>
            {map[role]}
        </span>
    );
};

export default RoleBadge;
